import { DOWNLOAD_FORM } from '../../../redux/queryResults/models/queryResults.types';
import { CHECKBOX_GROUP_TYPES } from '../../NQTCheckBox/NQTCheckBox.models';
import { DownloadFormatsDictionary } from './DownloadPanel.interfaces';

export const TAB_TYPE: CHECKBOX_GROUP_TYPES = 'DOWNLOAD_TAB';
export const TEST_TYPE: CHECKBOX_GROUP_TYPES = 'DOWNLOAD_TEST';
export const EXCEL_OPT_TYPE: CHECKBOX_GROUP_TYPES = 'EXCEL_OPTION';

export const ITEM_LIST_COL_HEADER_LABELS = [
  'QuestionID',
  'Description',
  'Grade',
  'Year',
  'Block',
  'Type',
  'Content Classifications',
  'Difficulty'
];

export const ITEM_LIST_DB_COLUMNS = [
  'questionID',
  'description',
  'grade',
  'year',
  'blockID',
  'type',
  'mainClassification',
  'difficulty'
];

export const DownloadFormatsDict: DownloadFormatsDictionary = {
  HTML: DOWNLOAD_FORM.HTML,
  PDF: DOWNLOAD_FORM.PDF,
  WORD: DOWNLOAD_FORM.WORD,
  EXCEL: DOWNLOAD_FORM.EXCEL
};